export function getViteEnvVariable(key: string): string | undefined {
  try {
    if (typeof import.meta !== 'undefined' && (import.meta as any).env) {
      return (import.meta as any).env[key] as string | undefined;
    }
  } catch (e) {
    // Ignore errors related to import.meta in environments that don't support it
  }

  return undefined;
}
